import React from 'react';
import { Player } from '../../domain/entities';
import './PlayerFace.css';

interface PlayerFaceProps {
    player: Player;
    teamColor?: string; // Optional team color to use as background
}

export const PlayerFace: React.FC<PlayerFaceProps> = ({ player, teamColor }) => (
    <div className="player-face" style={{ backgroundColor: teamColor || 'var(--primary-color)' }}>
        <span style={{ filter: `hue-rotate(${player.hue}deg) saturate(1.5) ${player.isLegend ? 'grayscale(1)' : ''}` }}>
            {player.faceEmoji}
        </span>
    </div>
);